import script from "./repair-order-detail.vue?vue&type=script&lang=ts&setup=true"
export * from "./repair-order-detail.vue?vue&type=script&lang=ts&setup=true"

import "./repair-order-detail.vue?vue&type=style&index=0&id=2d50ad27&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d50ad27"]])

export default __exports__